export const FETCH_DISHES = {
  START: 'START_FETCH_DISHES',
  COMPLETE: 'COMPLETE_FETCH_DISHES',
  FAIL: 'FAIL_FETCH_DISHES',
  CLEANUP: 'CLEANUP_FETCH_DISHES',
}

export const UPDATE_DISH = {
  START: 'START_UPDATE_DISH',
  COMPLETE: 'COMPLETE_UPDATE_DISH',
  FAIL: 'FAIL_UPDATE_DISH',
}

export const UPDATE_DISH_AI_SUGGESTIONS = {
  START: 'START_UPDATE_DISH_AI_SUGGESTIONS',
  COMPLETE: 'COMPLETE_UPDATE_DISH_AI_SUGGESTIONS',
  FAIL: 'FAIL_UPDATE_DISH_AI_SUGGESTIONS',
}

export const FETCH_INGREDIENT_EXPLANATIONS = {
  START: 'START_FETCH_INGREDIENT_EXPLANATIONS',
  COMPLETE: 'COMPLETE_FETCH_INGREDIENT_EXPLANATIONS',
  FAIL: 'FAIL_FETCH_INGREDIENT_EXPLANATIONS',
  CLEANUP: 'CLEANUP_FETCH_INGREDIENT_EXPLANATIONS',
}

export const FETCH_DISH_NAMES = {
  START: 'START_FETCH_DISH_NAMES',
  COMPLETE: 'COMPLETE_FETCH_DISH_NAMES',
  FAIL: 'FAIL_FETCH_DISH_NAMES',
}

export const FETCH_DISHES_AVAILABLE_FOR_QA_COUNTS = {
  START: 'START_FETCH_DISHES_AVAILABLE_FOR_QA_COUNTS',
  COMPLETE: 'COMPLETE_FETCH_DISHES_AVAILABLE_FOR_QA_COUNTS',
  FAIL: 'FAIL_FETCH_DISHES_AVAILABLE_FOR_QA_COUNTS',
}

export const FETCH_DISH_CURATION_DATES = {
  START: 'START_FETCH_DISH_CURATION_DATES',
  COMPLETE: 'COMPLETE_FETCH_DISH_CURATION_DATES',
  FAIL: 'FAIL_FETCH_DISH_CURATION_DATES',
}

export const FETCH_DISHES_USED_METADATA_COUNTS = {
  START: 'START_FETCH_DISHES_USED_METADATA_COUNTS',
  COMPLETE: 'COMPLETE_FETCH_DISHES_USED_METADATA_COUNTS',
  FAIL: 'FAIL_FETCH_DISHES_USED_METADATA_COUNTS',
}

export const FETCH_DISHES_AVAILABLE_FOR_QC_COUNTS = {
  START: 'START_FETCH_DISHES_AVAILABLE_FOR_QC_COUNTS',
  COMPLETE: 'COMPLETE_FETCH_DISHES_AVAILABLE_FOR_QC_COUNTS',
  FAIL: 'FAIL_FETCH_DISHES_AVAILABLE_FOR_QC_COUNTS',
}

export const FETCH_DISHES_PROGRESS_COUNTS = {
  START: 'START_FETCH_DISHES_PROGRESS_COUNTS',
  COMPLETE: 'COMPLETE_FETCH_DISHES_PROGRESS_COUNTS',
  FAIL: 'FAIL_FETCH_DISHES_PROGRESS_COUNTS',
}

export const FETCH_DISH_QA_DATES = {
  START: 'START_FETCH_DISH_QA_DATES',
  COMPLETE: 'COMPLETE_FETCH_DISH_QA_DATES',
  FAIL: 'FAIL_FETCH_DISH_QA_DATES',
}

export const UPDATE_DISH_STATUS_FLAG = {
  START: 'START_UPDATE_DISH_STATUS_FLAG',
  COMPLETE: 'COMPLETE_UPDATE_DISH_STATUS_FLAG',
  FAIL: 'FAIL_UPDATE_DISH_STATUS_FLAG',
}

export const UPDATE_DISH_TYPE_BY_MENU_TITLE = {
  START: 'START_UPDATE_DISH_TYPE_BY_MENU_TITLE',
  COMPLETE: 'COMPLETE_UPDATE_DISH_TYPE_BY_MENU_TITLE',
  FAIL: 'FAIL_UPDATE_DISH_TYPE_BY_MENU_TITLE',
}

export const UPDATE_DISH_INGREDIENT_DISCREPANCY_ACCEPTED = {
  START: 'START_UPDATE_DISH_INGREDIENT_DISCREPANCY_ACCEPTED',
  COMPLETE: 'COMPLETE_UPDATE_DISH_INGREDIENT_DISCREPANCY_ACCEPTED',
  FAIL: 'FAIL_UPDATE_DISH_INGREDIENT_DISCREPANCY_ACCEPTED',
}

export const UPDATE_DISH_TABLE_HOTKEYS = 'UPDATE_DISH_HOTKEYS'

export const UPDATE_DISH_REMOVE_TIER_ONE_OVERRIDE_CONFIRMATION =
  'UPDATE_DISH_SHOW_TIER_REMOVE_OVERRIDE_CONFIRMATION'

export const UPDATE_DISH_INGREDIENTS_DRAWER_HOTKEYS =
  'UPDATE_DISH_INGREDIENTS_DRAWER_HOTKEYS'

export const UPDATE_DISH_DRAWER = 'UPDATE_DISH_DRAWER'
